
































import Vue from 'vue'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection, DxEditing } from 'devextreme-vue/data-grid'
import { ProjectBookingPositionen } from '@/model/project/ProjectBookingPositionen'

interface ComponentData {

}

export default Vue.extend({
  name: 'BookingAssistant2',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection,
    DxEditing
  },

  props: {
    step2Data: Array as () => ProjectBookingPositionen[]
  },

  data (): ComponentData {
    return {

    }
  },

  watch: {

  },

  computed: {

  },

  methods: {
    formatNumber(value: number | null, digital: number): any {
      if(value !== null) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },
  },

  mounted () {}
})
